<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                    >
                        <h1 class="mt-6 mb-6">404 {{ $t('headings.Not Found') }}</h1>

                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <v-card-text>
                                <v-icon large light>mdi-bug</v-icon> {{ $t("The page you were looking for was not found") }}
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>
    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    export default {
        name: "NotFound",
        components: {
            'Footer': Footer
        },
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + '404 Not Found',
            htmlAttrs: {
              lang: i18n.locale
            },
            meta: [
              { name: 'robots', content: 'noindex' },
              { name: 'prerender-status-code',  content: '404' }
            ]
          }
        },
        mounted () {

            window.prerenderReady = true;

        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
          capitalizeFirstLetter(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
          },
        }
    }
</script>

<style scoped>

</style>
